import { makeAutoObservable, action } from 'mobx'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { formDataExample } from '../Data'

class ElementStore {
  constructor(elementData) {
    makeAutoObservable(this)
    this.data = elementData
  }
}

class PageStore {
  constructor(pageData) {
    makeAutoObservable(this)
    this.data = pageData
    this.elements = pageData.elements.map(
      (elementData) => new ElementStore(elementData)
    )
  }
}

class FormBuilderStore {
  formData = formDataExample
  isSidebarEditorOpen = true
  isSidebarPageOpen = true
  zoom = 50
  pages = []

  constructor(url_code) {
    makeAutoObservable(this)
    this.url_code = url_code
    this.initPages()
  }

  initPages = action(() => {
    this.pages = this.formData.pages.map((pageData) => new PageStore(pageData))
  })

  updateFormData = action((newData) => {
    this.formData = newData
    this.initPages()
  })

  toggleIsSidebarEditorOpen = action(() => {
    this.isSidebarEditorOpen = !this.isSidebarEditorOpen
  })

  toggleIsSidebarPageOpen = action(() => {
    this.isSidebarPageOpen = !this.isSidebarPageOpen
  })

  handleChangeZoom = action((value) => {
    this.zoom = value
  })
}

const FormBuilderContext = React.createContext()

const FormBuilderProvider = observer(({ children }) => {
  const { url_code } = useParams()
  const store = useMemo(() => new FormBuilderStore(url_code), [url_code])
  return (
    <FormBuilderContext.Provider value={store}>
      {children}
    </FormBuilderContext.Provider>
  )
})

export { FormBuilderContext, FormBuilderProvider }
